//Hide all the controls
export const hideAllControls = (data) => {
    return { type: "HIDE_ALL_CONTROLS", payload: {controlsVisible: false} }
}

//---Move Menu-----------------------------:

//Update the move menu data
export const setMoveMenu = (data) => {
    return { type: "SET_MOVEMENU", payload: data }
}

//Display the move menu
export const showMoveMenu = (data) => {
    return { type: "SHOW_MOVEMENU", payload: data}
}
